import { useTranslation } from 'react-i18next';
import { NotificationBanner } from '@nexus/ari-lib/components/notification-banner';
import { useNotificationFeed } from '@nexus/supabase';

import { useStore } from '../lib/store';

/** Server-driven banners (CLOUD-1289). The cards float over the page. */
export function NotificationBannerHost() {
  const { t } = useTranslation();
  const userId = useStore((s) => s.supabaseUser?.id);
  const { notifications, dismiss } = useNotificationFeed({ surface: 'cloud', userId });

  return <NotificationBanner items={notifications} onDismiss={dismiss} dismissLabel={t('accessibility.close')} />;
}
